import { render, staticRenderFns } from "./chantal4.vue?vue&type=template&id=1aa7365c"
import script from "./chantal4.vue?vue&type=script&lang=js"
export * from "./chantal4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports